const getEvent = (actionType) =>
  actionType === 'reserve' ? ['Schedule', 'agendapro-reserve'] : ['InitiateCheckout', 'agendapro-begincheckout'];

export const FbPixel = {
  pageview() {
    window.fbq('track', 'PageView');
  },
  event(name, options = {}) {
    const events = getEvent(name);

    events.forEach((event) => {
      window.fbq('track', event, options);
    });
  },
};
